// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"Withdrawal_modal-content_1mBQW","mountain-icon":"Withdrawal_mountain-icon_JPLGt","h-md-full":"Withdrawal_h-md-full_5hQHX"};